import Box from '../../lib/appfuse-react/component/Box';
import Banner from '../../component/Banner';
import { ThankContent } from './components';
import { useStyles } from './styles';

function Thank() {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Banner />
      <ThankContent />
    </Box>
  );
}

export default Thank;
